<button type="button" *ngIf="product" (click)="openModal($event)">
  <img class="sign" src="/assets/svg/dollar-3.svg" alt="B">
    <div class="text-desc">
      {{ ((product.offerPrice && product.offerPrice > 0) ? product.offerPrice : product.fullPrice ) | multiCountryCurrency:true}}
    </div>
  <img class="arrow" src="/assets/svg/lnr-chevron-down.svg" alt="Mostrar conversion">
</button>
<button type="button" *ngIf="billing" [class.billing]="billing" (click)="openModal($event)">
  <img class="sign" src="/assets/svg/dollar-3.svg" alt="">
    <div class="text-desc">
      Total en {{ billing.total | multiCountryCurrency:true}}
    </div>
  <img class="arrow" src="/assets/svg/lnr-chevron-down.svg" alt="Mostrar conversion">
</button>